<template>
  <div class="el-dropdown-item__avatar-row">
    <div class="el-dropdown-item__avatar-column">
      <avatar :person="item.creator" />
      <div class="el-dropdown-item__avatar-wrapper">
        <i v-if="item.isConversationThread" class="ddi ddi-conversation" />
        <i v-else class="ddi ddi-chat-balloon" />
      </div>
    </div>
    <div class="el-dropdown-item__avatar-column__details">
      <div class="details__subtitle" v-html="item.title" />
      <div class="details__entity" v-html="item.entity" />
      <div class="details__description" v-html="item.description" />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

import responseIcon from '@/assets/img/icons/auto-responder.svg'
import commentIcon from '@/assets/img/icons/description.svg'

export default defineComponent({
  name: 'DdGlobalSearchAvatarRow',
  props: {
    /**
     * Activate search
     */
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isReplyLogo: {
        src: responseIcon,
        alt: '',
      },
      isCommentLogo: {
        src: commentIcon,
        alt: '',
      },
    }
  },
})
</script>
<style lang="scss">
.el-dropdown-item__avatar {
  position: relative;
  display: inline-block;
  width: calc(100% - 16px);
  margin-right: 8px;
  margin-left: 8px;
  overflow: hidden;
  word-wrap: break-word;
  border-radius: 8px;

  .title {
    font-size: 15px;
    font-weight: 500;
    line-height: 1.47;
    color: var(--color-text-secondary);
  }

  &-row {
    display: inline-block;
    width: 100%;
  }

  &-wrapper {
    position: absolute;
    top: 24px;
    left: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background-color: $color--blue;
    border-radius: 4px;

    > .ddi {
      color: #fff !important;
      font-size: 12px;
      left: 2px;
    }
  }

  &-column {
    position: absolute;
    width: 100%;
    height: 100%;
    margin-top: 14px;

    @include media-breakpoint-up(md) {
      margin-left: -2px;
    }

    &__details {
      width: calc(100% - 46px);
      padding-top: 14px;
      margin-right: -7px;
      margin-left: 45px;
      overflow: hidden;
      word-wrap: break-word;
    }
  }

  .details {
    &__subtitle {
      @include lettering--p;
      font-weight: $bold;
    }

    &__entity {
      margin-bottom: 6px;
      @include lettering--p-sm;
      color: var(--color-text-third);
    }

    &__description {
      > p {
        @include lettering--p-sm;
      }
    }
  }
}
</style>
